// extracted by mini-css-extract-plugin
module.exports = {"section":"projects-module--section--3sd53","spacer":"projects-module--spacer--217Nl"};